/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs__return = /** @type {(inputs: {}) => string} */ () => {
	return `Vrátit objednávku`
};

const da__return = /** @type {(inputs: {}) => string} */ () => {
	return `Returnér min ordre`
};

const de__return = /** @type {(inputs: {}) => string} */ () => {
	return `Bestellung zurückgeben`
};

const en__return = /** @type {(inputs: {}) => string} */ () => {
	return `Return my order`
};

const es__return = /** @type {(inputs: {}) => string} */ () => {
	return `Devolver mi pedido`
};

const fr__return = /** @type {(inputs: {}) => string} */ () => {
	return `Retourner ma commande`
};

const hu__return = /** @type {(inputs: {}) => string} */ () => {
	return `Rendelés visszaküldése`
};

const it__return = /** @type {(inputs: {}) => string} */ () => {
	return `Restituisci il mio ordine`
};

const nl__return = /** @type {(inputs: {}) => string} */ () => {
	return `Bestelling retourneren`
};

const pl__return = /** @type {(inputs: {}) => string} */ () => {
	return `Zwróć zamówienie`
};

const pt__return = /** @type {(inputs: {}) => string} */ () => {
	return `Devolver meu pedido`
};

const sv__return = /** @type {(inputs: {}) => string} */ () => {
	return `Returnera min beställning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const _return = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr._return(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("_return", locale)
	if (locale === "cs") return cs__return(inputs)
	if (locale === "da") return da__return(inputs)
	if (locale === "de") return de__return(inputs)
	if (locale === "en") return en__return(inputs)
	if (locale === "es") return es__return(inputs)
	if (locale === "fr") return fr__return(inputs)
	if (locale === "hu") return hu__return(inputs)
	if (locale === "it") return it__return(inputs)
	if (locale === "nl") return nl__return(inputs)
	if (locale === "pl") return pl__return(inputs)
	if (locale === "pt") return pt__return(inputs)
	return sv__return(inputs)
};
export { _return as "return" }